export const DEFAULT = 'DEFAULT';
export const EDIT = 'EDIT';
export const REPLY = 'REPLY';
export const ADD_NEW = 'ADD_NEW';
